// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper[data-v-09045082]{max-width:1920px;border:none;position:relative;min-width:320px;margin:0 auto;padding:40px 104px 0;height:100%;background:#fff;overflow-x:hidden}@media (min-width:1921px){.content-wrapper[data-v-09045082]{border:1px solid #9b9b9b}}@media (max-width:1199px){.content-wrapper[data-v-09045082]{padding:35px 40px 0;border:none}}@media (max-width:767px){.content-wrapper[data-v-09045082]{padding:20px 20px 0}}", ""]);
// Exports
module.exports = exports;
